
import { createSlice } from '@reduxjs/toolkit';
import { getAuthProps, setAuthProps, signOut } from '../../lib/authenticationLibrary';

const authData = getAuthProps();

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: (authData != null),
        user: (authData?.user), //Set user data from cookie.
        token: (authData?.token), //Set token data from cookie.
        authData,
        isLogedin: false,
        adminUserId: null,
    },
    reducers: {
        authentication: (state, action) => {
            state.isAuthenticated = true
            state.isLogedin = true;
            state.isAuthenticated = true;
            state.adminUserId= action.payload.adminUserId;
            setAuthProps(action.payload);
        },
        logout: (state) => {
            state.isLogedin = false;
            signOut();
        },
    },
});

export const { authentication, logout } = authSlice.actions;

export default authSlice.reducer;
